import React, { useEffect, useState } from 'react';
import {
  ChatRequestsListModalOverlay,
  ChatRequestsListModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestTabs,
  ChatRequestTab,
  ChatRequestsList,
  ChatRequestItem,
  ChatRequestItemInfo,
  ChatRequestItemName,
  ChatRequestItemConnectId,
  ChatRequestItemActions,
  ChatRequestActionButton,
  EmptyRequestsMessage,
} from '../../../styles/UserWorkspacePageStyles';
import { useT } from '../../../LocaleContext';

const renderRequestItem = ({
  request,
  index,
  isIncoming,
  onAccept,
  onReject,
  onCancel,
  onCancelRequest,
  t,
}) => {
  const connectId = isIncoming
    ? request.from_user_connect_id
    : request.to_user_connect_id;
  const userName = isIncoming
    ? request.from_user_name
    : request.to_user_name;
  const key = isIncoming
    ? `incoming-${connectId}-${index}`
    : `outgoing-${connectId}-${index}`;

  return (
    <ChatRequestItem key={key}>
      <ChatRequestItemInfo>
        {userName && (
          <ChatRequestItemName>
            {userName || t('call.unknownUser')}
          </ChatRequestItemName>
        )}
        <ChatRequestItemConnectId>
          {isIncoming ? 'id: ' : 'connect_id: '}{connectId}
        </ChatRequestItemConnectId>
      </ChatRequestItemInfo>
      <ChatRequestItemActions>
        {isIncoming && onAccept && (
          <ChatRequestActionButton
            variant="accept"
            onClick={() => onAccept(connectId)}
          >
            {t('common.accept')}
          </ChatRequestActionButton>
        )}
        {isIncoming && onReject && (
          <ChatRequestActionButton
            variant="reject"
            onClick={() => onReject(connectId)}
          >
            {t('common.reject')}
          </ChatRequestActionButton>
        )}
        {!isIncoming && (onCancel || onCancelRequest) && (
          <ChatRequestActionButton
            variant="reject"
            onClick={() => {
              if (onCancelRequest) {
                onCancelRequest(request);
              } else if (onCancel) {
                onCancel(connectId);
              }
            }}
          >
            {t('common.cancel')}
          </ChatRequestActionButton>
        )}
      </ChatRequestItemActions>
    </ChatRequestItem>
  );
};

const ChatRequestsListModal = ({
  isOpen,
  onClose,
  initialTab = 'incoming',
  incomingRequests = [],
  outgoingRequests = [],
  incomingCount = 0,
  onAccept,
  onReject,
  onCancelRequest,
}) => {
  const t = useT();
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (isOpen) {
      setActiveTab(initialTab);
    }
  }, [isOpen, initialTab]);

  if (!isOpen) return null;

  const isIncoming = activeTab === 'incoming';
  const requests = isIncoming ? incomingRequests : outgoingRequests;
  const emptyMessage = isIncoming ? t('modals.noIncoming') : t('modals.noOutgoing');

  return (
    <ChatRequestsListModalOverlay onClick={onClose}>
      <ChatRequestsListModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <div />
          <ChatRequestModalTitle>{t('modals.chatInvites')}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <ChatRequestTabs>
          <ChatRequestTab
            type="button"
            $active={activeTab === 'incoming'}
            onClick={() => setActiveTab('incoming')}
          >
            {t('modals.incoming')}{incomingCount > 0 ? ` (${incomingCount})` : ''}
          </ChatRequestTab>
          <ChatRequestTab
            type="button"
            $active={activeTab === 'outgoing'}
            onClick={() => setActiveTab('outgoing')}
          >
            {t('modals.outgoing')}
          </ChatRequestTab>
        </ChatRequestTabs>
        <ChatRequestsList>
          {requests.length > 0 ? (
            requests.map((request, index) => renderRequestItem({
              request,
              index,
              isIncoming,
              onAccept,
              onReject,
              onCancelRequest,
              t,
            }))
          ) : (
            <EmptyRequestsMessage>{emptyMessage}</EmptyRequestsMessage>
          )}
        </ChatRequestsList>
      </ChatRequestsListModalContent>
    </ChatRequestsListModalOverlay>
  );
};

export default ChatRequestsListModal;
